import { Col, Row } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LayoutInner from '../../../../layouts/main/components/layout-inner/layout-inner';
import CustomButton from '../../../../shared/components/buttons/custom-button/custom-button';
import ExportModal from '../../../../shared/components/export-modal/export-modal';
import { ExportType } from '../../../../shared/components/export-modal/export-type';
import PageTitle from '../../../../shared/components/page-title/page-title';
import { exportTraceLogsModalId } from '../../../../shared/constants/constants';
import { useAppDispatch } from '../../../../store/hooks';
import AuthGuard from '../../../auth/components/auth-guard/auth-guard';
import { openModal } from '../../../ui/store/ui-slice';
import { UserPermissionType } from '../../../user/models/user-permission-type';
import ClientUserTraceLogsTable from '../../components/client-user-trace-logs-table/client-user-trace-logs-table';
import styles from './client-user-trace-logs.module.css';

const ClientUserTraceLogs = (): JSX.Element => {
  const { t } = useTranslation(['client-users', 'common']);
  const dispatch = useAppDispatch();

  return (
    <AuthGuard permission={UserPermissionType.ViewTracelogs}>
      <Helmet>
        <title>{t('userTraceLogs.title')}</title>
      </Helmet>
      <LayoutInner>
        <Row justify="space-between" className={styles.headerRow}>
          <Col>
            <PageTitle>{t('userTraceLogs.title')}</PageTitle>
          </Col>
          <Col>
            <CustomButton
              className={styles.exportBtn}
              type="primaryLight"
              onClick={() =>
                dispatch(
                  openModal({
                    id: exportTraceLogsModalId,
                    props: {
                      type: ExportType.ClientUser,
                    },
                  }),
                )
              }
            >
              {t('action.export', { ns: 'common' })}
            </CustomButton>
          </Col>
        </Row>
        <ClientUserTraceLogsTable />
      </LayoutInner>
      <ExportModal />
    </AuthGuard>
  );
};

export default ClientUserTraceLogs;
